import React, {useContext, useEffect, useState} from 'react';
import Column from "components/Grid/Column";
import NumberField from './FormComponents/NumberField';
import Row from 'components/Grid/Row';
import {FormContext} from "./FormComponents/Form";

function FeetInchesForm({label, uniqueName, fieldName = '', cut}) {
    const formContext = useContext(FormContext);
    const [feet, setFeet] = useState(0);
    const [inches, setInches] = useState(0);

    // const changeInchesToFeet = (inches) => {
    //     return Math.floor(inches/12);
    // }

    // const changeInchesToInches = (inches) => {
    //     return inches%12;
    // }

    // const calculateTotalInches = (feet, inches) => {
    //     return feet*12 + inches;
    // }

    // useEffect(() => {
    //     setFeet((currentFeet) => (cut?.[uniqueName] ? changeInchesToFeet(cut[uniqueName]) : 0));
    //     setInches((currentInches) => (cut?.[uniqueName] ? changeInchesToInches(cut[uniqueName]) : 0));
    // }, [cut[uniqueName]]);

    // const updateState = (e, isFeet = false) => {
    //     const value = parseInt(e.target.value);
    //     let totalInches = 0;

    //     if (isFeet) {
    //         setFeet(value);
    //         totalInches = calculateTotalInches(value, inches);
    //     } else {
    //         setInches(value);
    //         totalInches = calculateTotalInches(feet, value);
    //     }

    //     if (fieldName === '') {
    //         formContext.inputChangeHandler(uniqueName, totalInches);
    //     } else {
    //         formContext.inputChangeHandler(fieldName + '.' + uniqueName, totalInches);
    //     }
    // }

    useEffect(() => {
        const totalInches = cut?.[uniqueName] ?? 0;
        setFeet(Math.floor(totalInches / 12));
        setInches(totalInches % 12);
        propagateChange(totalInches);
    }, [cut?.[uniqueName]]);

    const handleFeetChange = (e) => {
        const rawValue = e.target.value;
        if (rawValue === '') {
            setFeet('');
            return;
        }

        const value = parseInt(rawValue);
        if (isNaN(value)) return;

        const totalInches = value * 12 + (parseInt(inches) || 0);
        setFeet(value);
        propagateChange(totalInches);
    };

    const handleInchesChange = (e) => {
        const rawValue = e.target.value;
        if (rawValue === '') {
            setInches('');
            return;
        }

        const value = parseInt(rawValue);
        if (isNaN(value)) return;

        setInches(value);
    };

    const propagateChange = (totalInches) => {
        const name = fieldName ? `${fieldName}.${uniqueName}` : uniqueName;
        formContext.inputChangeHandler(name, totalInches);
    };

    const handleInchesBlur = () => {
    if (inches === '') setInches(0);
        const totalInches = (parseInt(feet) || 0) * 12 + (parseInt(inches) || 0);
        const normalizedFeet = Math.floor(totalInches / 12);
        const normalizedInches = totalInches % 12;

        setFeet(normalizedFeet);
        setInches(normalizedInches);
        propagateChange(totalInches);
    };

    const handleFeetBlur = () => {
        if (feet === '') setFeet(0);
        const totalInches = (parseInt(feet) || 0) * 12 + (parseInt(inches) || 0);
        propagateChange(totalInches);
    };

    const handleFeetFocus = () => {
        if (feet === 0) setFeet('');
    };

    const handleInchesFocus = () => {
        if (inches === 0) setInches('');
    };

    if (label === "Depth") {
        return (
            <Column width={1/3}>
                <h5 style={{marginBottom: '5px'}}>{label}:</h5>
                <Row style={{marginBottom: '20px'}}>
                    {/* <NumberField
                        label={`ft.`}
                        onChange={handleFeetChange}
                        onFocus={handleFeetFocus}
                        onBlur={handleFeetBlur}
                        value={feet}
                        style={{width: '100px', marginRight: '4px'}}
                    /> */}
                    <NumberField
                        label={`in.`}
                        onChange={handleInchesChange}
                        onFocus={handleInchesFocus}
                        onBlur={handleInchesBlur}
                        value={inches ?? ''}
                        style={{width: '150px'}}
                    />
                </Row>
            </Column>
        )
    }

     return (
        <Column width={1/3}>
            <h5 style={{marginBottom: '5px'}}>{label}:</h5>
            <Row style={{marginBottom: '20px'}}>
                <NumberField
                    label={`ft.`}
                    onChange={handleFeetChange}
                    onFocus={handleFeetFocus}
                    onBlur={handleFeetBlur}
                    value={feet ?? ''}
                    style={{width: '100px', marginRight: '4px'}}
                />
                <NumberField
                    label={`in.`}
                    onChange={handleInchesChange}
                    onBlur={handleInchesBlur}
                    onFocus={handleInchesFocus}
                    value={inches ?? ''}
                    style={{width: '100px'}}
                />
             </Row>
         </Column>
    )
}

export default FeetInchesForm;
